<div class="modal fade show"
    tabindex="-1"
    role="dialog"
    aria-labelledby="addressModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-sm"
        role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title"
                    id="addressModalLabel">{{ header }}</h3>
                <button type="button"
                    class="close"
                    aria-label="Close"
                    (click)="close()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p>{{ data }}</p>
            </div>
            <div class="modal-footer">
                <button type="submit"
                    class="btn btn-primary btn-sm"
                    (click)="yes()">Yes</button>
                <button type="button"
                    class="btn btn-primary btn-sm"
                    (click)="close() ">No</button>
            </div>
        </div>
    </div>
</div>